import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js'

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import { unregister } from './registerServiceWorker';

import "./index.css";
import Amplify, { PubSub } from "aws-amplify";
import { AWSIoTProvider } from '@aws-amplify/pubsub/lib/Providers';

import config from "./config";
import '../node_modules/font-awesome/css/font-awesome.min.css';


Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID
  },
  API: {
    endpoints: [
      {
        name: "AltiomData",
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      },
    ]
  }

});

Amplify.addPluggable(new AWSIoTProvider({
     aws_pubsub_region: 'eu-west-1',
     aws_pubsub_endpoint: 'wss://a3duuhb6j1ul52-ats.iot.eu-west-1.amazonaws.com/mqtt',
   }));

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById("root")
);
unregister();
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js